import {
	DYNAMIC_MPSK_ST_TT,
	OPEN_ST_TT,
	OWE_TRANSITION_ST_TT,
	STATIC_MPSK_ST_TT,
	WPA2_EAP_ST_TT,
	WPA2_PSK_MIXED_ST_TT,
	WPA2_PSK_ST_TT,
	WPA3_ENTERPRISE_ST_TT,
	WPA3_ENTERPRISE_TRANSITION_ST_TT,
	WPA3_PERSONAL_MIXED_ST_TT,
	WPA3_PERSONAL_ST_TT,
	WPA3_SUITE_B_ST_TT,
	WPA_PSK_ST_TT,
} from '../../constants/tooltipConstants';

export const optionItem = [
	{
		label: 'Server-Name-1',
		value: 'serverName',
	},
	{
		label: 'Local-Server',
		value: 'localServer',
	},
	{
		label: 'Demo-Server-3',
		value: 'demoServer',
	},
	{
		label: 'AAA-Bangalore',
		value: 'AAABanglore',
	},
];
export const vlanPriorityList = [
	{
		value: 'vlan1',
		label: 'vlan1',
	},
	{
		value: 'vlan2',
		label: 'vlan2',
	},
	{
		value: 'vlan3',
		label: 'vlan3',
	},
];
export const getAccessModeButtons = (modeType) => {
	switch (modeType) {
		case 'basic':
			return [
				{ label: 'LAN', value: 'bridge' },
				{ label: 'WAN', value: 'nat' },
				{ label: 'Tunnel', value: 'eogreTunnel' },
			];
		case 'advanced':
			return [
				{ label: 'LAN', value: 'bridge' },
				{ label: 'WAN', value: 'nat' },
			];
		case 'tipSSID':
			return [{ label: 'Tunnel', value: '-1' }];
		case 'nonNat':
			return [
				{ label: 'LAN', value: 'bridge' },
				{ label: 'Tunnel', value: 'eogreTunnel' },
			];
		default:
			return [
				{ label: 'Bridge', value: 'bridge' },
				{ label: 'NAT', value: 'nat' },
				{ label: 'Tunnel', value: 'eogreTunnel' },
			];
	}
};
export const macAclButtons = [
	{ label: 'Allow', value: '1' },
	{ label: 'Deny', value: '0' },
];

export const vlanProtoOptions = [
	{ label: '802.1q', value: '0' },
	{ label: '802.1ad (Q-in-Q)', value: '1' },
];
export const urlFilteringButtons = [
	{
		label: 'Allow',
		value: '2',
		// tooltipContent: 'Whitelist: Allow only given URLs/categories',
	},
	{
		label: 'Deny',
		value: '1',
		// tooltipContent: 'Blacklist: Block the given URLs/categories',
	},

	{
		label: 'Default',
		value: '3',
		tooltipContent: 'Enter comma separated values ',
	},
];
export const limits = [
	{ label: 'Per VAP', value: 'per_vap' },
	{ label: 'Per Client', value: 'per_client' },
];
export const messageExchangeOptions = [
	{ label: 'Air', value: 'air' },
	{ label: 'DS', value: 'ds' },
];

export const securityTypeOptions = [
	{
		label: 'WPA2 Personal',
		value: '3',
		tooltipText: WPA2_PSK_ST_TT,
		tooltipWidth: 250,
	},
	{
		label: 'WPA2 Enterprise',
		value: '5',
		tooltipText: WPA2_EAP_ST_TT,
		tooltipWidth: 250,
	},
	{
		label: 'WPA3 Personal',
		value: '6',
		tooltipText: WPA3_PERSONAL_ST_TT,
		tooltipWidth: 250,
	},
	{
		label: 'WPA3 Enterprise',
		value: '10',
		tooltipText: WPA3_ENTERPRISE_ST_TT,
		tooltipWidth: 250,
	},
	{
		label: 'WPA3 Suite-B',
		value: '8',
		tooltipText: WPA3_SUITE_B_ST_TT,
		tooltipWidth: 250,
	},
	{
		label: 'WPA2 Personal TM',
		value: '4',
		tooltipText: WPA2_PSK_MIXED_ST_TT,
		tooltipWidth: 250,
	},
	{
		label: 'WPA3 Personal TM',
		value: '7',
		tooltipText: WPA3_PERSONAL_MIXED_ST_TT,
		tooltipWidth: 250,
	},
	{
		label: 'WPA3 Enterprise TM',
		value: '11',
		tooltipText: WPA3_ENTERPRISE_TRANSITION_ST_TT,
		tooltipWidth: 250,
	},
	{
		label: 'Open (Weak)',
		value: '0',
		tooltipText: OPEN_ST_TT,
		tooltipWidth: 250,
	},
	{
		label: 'OWE TM',
		value: '9',
		tooltipText: OWE_TRANSITION_ST_TT,
		tooltipWidth: 250,
	},
	{
		label: 'Static MPSK',
		value: '12',
		tooltipText: STATIC_MPSK_ST_TT,
		tooltipWidth: 250,
	},
	{
		label: 'Dynamic MPSK',
		value: '13',
		tooltipText: DYNAMIC_MPSK_ST_TT,
		tooltipWidth: 250,
	},

	{
		label: 'WPA PSK (Weak)',
		value: '2',
		tooltipText: WPA_PSK_ST_TT,
		tooltipWidth: 250,
	},
];

export const securityTypeOptionsTip = [
	{
		label: 'Open (Weak)',
		value: '0',
		tooltipText: OPEN_ST_TT,
		tooltipWidth: 250,
	},
	{
		label: 'OWE TM',
		value: '14',
		tooltipText: OWE_TRANSITION_ST_TT,
		tooltipWidth: 250,
	},
	{
		label: 'WPA3 Personal',
		value: '6',
		tooltipText: WPA3_PERSONAL_ST_TT,
		tooltipWidth: 250,
	},
	{
		label: 'WPA3-Personal Mixed',
		value: '7',
		tooltipText: WPA3_PERSONAL_MIXED_ST_TT,
		tooltipWidth: 250,
	},

	{
		label: 'WPA2-Personal',
		value: '3',
		tooltipText: WPA2_PSK_ST_TT,
		tooltipWidth: 250,
	},
	{
		label: 'WPA2 Personal TM',
		value: '4',
		tooltipText: WPA2_PSK_MIXED_ST_TT,
		tooltipWidth: 250,
	},
	{
		label: 'WPA2 Enterprise',
		value: '5',
		tooltipText: WPA2_EAP_ST_TT,
		tooltipWidth: 250,
	},
	{
		label: 'Dynamic MPSK',
		value: '13',
		tooltipText: DYNAMIC_MPSK_ST_TT,
		tooltipWidth: 250,
	},

	{
		label: 'WPA PSK (Weak)',
		value: '2',
		tooltipText: WPA_PSK_ST_TT,
		tooltipWidth: 250,
	},
	{
		label: 'OWE',
		value: '15',
		tooltipText: '',
		tooltipWidth: 250,
	},
	{
		label: 'WPA - EAP',
		value: '16',
		tooltipText: '',
		tooltipWidth: 250,
	},
	{
		label: 'WPA3-192-EAP',
		value: '17',
		tooltipText: '',
		tooltipWidth: 250,
	},
	{
		label: 'WPA3 Enterprise',
		value: '18',
		tooltipText: '',
		tooltipWidth: 250,
	},
	{
		label: 'WPA3-MIXED-EAP',
		value: '19',
		tooltipText: '',
		tooltipWidth: 250,
	},
];

export const securityTypeOptionsTip6GHz = [
	{
		label: 'WPA3 Personal',
		value: '6',
		tooltipText: WPA3_PERSONAL_ST_TT,
		tooltipWidth: 250,
	},
	{
		label: 'OWE',
		value: '15',
		tooltipText: '',
		tooltipWidth: 250,
	},
	{
		label: 'WPA3 Enterprise',
		value: '18',
		tooltipText: '',
		tooltipWidth: 250,
	},
	{
		label: 'WPA3-192-EAP',
		value: '17',
		tooltipText: '',
		tooltipWidth: 250,
	},
	{
		label: 'Radius MPSK',
		value: '20',
		tooltipText: '',
		tooltipWidth: 250,
	},
	{
		label: 'Local MPSK',
		value: '21',
		tooltipText: '',
		tooltipWidth: 250,
	},
];

export const securityTypeOptionsTipAllBands = [
	...securityTypeOptionsTip,
	...securityTypeOptionsTip6GHz.filter(
		(option) =>
			!securityTypeOptionsTip.some(
				(existingOption) => existingOption.value === option.value
			)
	),
];
// securityTypeList = [
// 	{ id: 15, name: 'OWE' },

// 	{ id: 16, name: 'WPA_EAP' },
// 	{ id: 17, name: 'WPA3_192_EAP' },
// 	{ id: 18, name: 'WPA3_EAP' },
// 	{ id: 19, name: 'WPA3_MIXED_EAP' },
// ];
export const vlanPriorityOptions = [
	{ label: 'Best Effort', value: '0' },
	{ label: 'Background', value: '1' },
	{ label: 'Excellent', value: '2' },
	{ label: 'Critical application', value: '3' },
	{ label: 'Video', value: '4' },
	{ label: 'Voice', value: '5' },
	{ label: 'Internetwork Control', value: '6' },
	{ label: 'Network Control', value: '7' },
];
export const radioConstants = [
	{ label: '2.4 GHz', value: 1 },
	{ label: '5 GHz', value: 0 },
	{ label: '5 GHz,2.4 GHz', value: 2 },
];

export const broadcastOptions = [
	{ label: 'Yes', value: 1 },
	{ label: 'No', value: 0 },
];

export const accessNetworkTypeOptions = [
	{ value: 2, label: 'Chargeable public networks' },
	{ value: 5, label: 'Emergency services only network' },
	{ value: 3, label: 'Free public network' },
	{ value: 4, label: 'Personal device network' },
	{ value: 0, label: 'Private network' },
	{ value: 1, label: 'Private network with guest access' },
	{ value: 14, label: 'Test or experimental' },
	{ value: 15, label: 'Wildcard' },
];
export const venueInfoOptions = [
	{ value: '0,0', label: 'Unspecified' },
	{ value: '1,7', label: 'Convention Center' },
	{ value: '1,13', label: 'Coffee Shop' },
	{ value: '2,0', label: 'Unspecified Business' },
	{ value: '7,1', label: 'Private Residence' },
];
export const ssidErrorConstants = {
	CANNOT_DELETE_OTHER_NODE_SSID:
		'SSIDs can only be deleted at the site in which it was created',
};
